import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export const TYPES = ["text", "password"];

const InputText = (props) => {
  const { className, innerRef, type = "text", ...inputProps } = props;
  const componentClass = classnames(
    "sal-input",
    `sal-input-${type}`,
    className,
  );

  return (
    <input
      className={componentClass}
      name={name}
      ref={innerRef}
      type={type}
      {...inputProps}
    />
  );
};

InputText.propTypes = {
  className: PropTypes.string,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.oneOf(TYPES),
};

// eslint-disable-next-line react/display-name
export default forwardRef((props, ref) => (
  <InputText innerRef={ref} {...props} />
));
